import { StationsState } from "entities/stations/types/store";

export const resetStationWithPrices = (state: StationsState) => {
  state.stationsWithPrices = {};
};
